import { render, staticRenderFns } from "./Texts.vue?vue&type=template&id=60e51fba&scoped=true&"
import script from "./Texts.vue?vue&type=script&lang=js&"
export * from "./Texts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e51fba",
  null
  
)

export default component.exports